"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SideBarModule = _interopRequireDefault(require("./SideBar.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var NotificationCounter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NotificationCounter, _React$Component);

  function NotificationCounter() {
    _classCallCheck(this, NotificationCounter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotificationCounter).apply(this, arguments));
  }

  _createClass(NotificationCounter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          active = _this$props.active,
          notificationCounterClick = _this$props.notificationCounterClick,
          children = _this$props.children;
      var classes = (0, _classnames.default)(_SideBarModule.default.notificationCounter, active && _SideBarModule.default.active, className);
      return _react.default.createElement("div", {
        className: classes,
        onClick: notificationCounterClick
      }, _react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, _react.default.createElement("path", {
        id: "Ellipse_1083_copy_4",
        "data-name": "Ellipse 1083 copy 4",
        className: "cls-1",
        d: "M2133,1447h-10a5,5,0,0,1-5-5v-10a5,5,0,0,1,5-5h7v1h-7a4,4,0,0,0-4,4v10a4,4,0,0,0,4,4h10a4,4,0,0,0,4-4v-7h1v7A5,5,0,0,1,2133,1447Zm-9.5-6h9a0.5,0.5,0,0,1,0,1h-9A0.5,0.5,0,0,1,2123.5,1441Zm0-7a0.5,0.5,0,0,1,0-1h5a0.5,0.5,0,0,1,0,1h-5Zm9.5,3.5a0.5,0.5,0,0,1-.5.5h-9a0.5,0.5,0,0,1,0-1h9A0.5,0.5,0,0,1,2133,1437.5Zm2-4.5a3,3,0,1,1,3-3A3,3,0,0,1,2135,1433Zm0-5a2,2,0,1,0,2,2A2.006,2.006,0,0,0,2135,1428Z",
        transform: "translate(-2118 -1427)"
      })), _react.default.createElement("div", {
        className: _SideBarModule.default.counterLabel
      }), children);
    }
  }]);

  return NotificationCounter;
}(_react.default.Component);

NotificationCounter.propTypes = {
  active: _propTypes.default.bool,
  notificationCounterClick: _propTypes.default.func
};
NotificationCounter.defaultProps = {
  active: false
};
var _default = NotificationCounter;
exports.default = _default;